import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from './components/Header';
import HomeContent from './components/HomeContent';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MaintenancePage from './components/MaintenancePage';

const App: React.FC = () => {
  const [showLogin, setShowLogin] = useState(false);

  const handleUserClick = () => {
    setShowLogin(true);
  };

  const handleBackFromLogin = () => {
    setShowLogin(false);
  };

  return (
    <Router>
      <Routes>
        <Route path="/maintenance" element={<MaintenancePage />} />
        <Route path="/" element={
          <Box sx={{ minHeight: '100vh' }}>
            <Header onUserClick={handleUserClick} />
            <Box sx={{ pt: '64px' }}>
              <HomeContent />
            </Box>
          </Box>
        } />
      </Routes>
    </Router>
  );
};

export default App; 